export class BiometryAuthCreditRequest {
    authCredit: boolean = false;
    observations: string = "";
}